(function() {
	'use strict';

	angular
		.module('diplomaApp')
		.run(['$http', httpPostRepair]);

	function httpPostRepair($http) {
		// Use x-www-form-urlencoded Content-Type
		$http.defaults.headers.post = {'Content-Type' : 'application/x-www-form-urlencoded'};
	}
}());